import { useSyncExternalStore } from 'react';

/*
 * Избранные модели сайта — в сайдбаре, в разделе «Избранное». Модели в меню
 * сами не попадают: их может быть десятки, и меню превратилось бы в схему.
 *
 * Хранится в браузере по короткому имени модели: оно общее у дева и прода,
 * так что звёздочка видна в обоих окружениях.
 */

const listeners = new Set<() => void>();
const cache = new Map<string, string[]>();

function key(siteId: string): string {
  return `faceta.favorites.${siteId}`;
}

function read(siteId: string): string[] {
  const cached = cache.get(siteId);

  if (cached !== undefined) {
    return cached;
  }

  let value: string[] = [];

  try {
    const raw = localStorage.getItem(key(siteId));
    const parsed: unknown = raw === null ? [] : JSON.parse(raw);

    if (Array.isArray(parsed)) {
      value = parsed.filter((item): item is string => typeof item === 'string');
    }
  } catch {
    // Хранилище браузера недоступно — избранное просто пустое.
  }

  cache.set(siteId, value);

  return value;
}

export function toggleFavorite(siteId: string, slug: string): void {
  const current = read(siteId);
  const next = current.includes(slug)
    ? current.filter((item) => item !== slug)
    : [...current, slug];

  cache.set(siteId, next);

  try {
    localStorage.setItem(key(siteId), JSON.stringify(next));
  } catch {
    // Не сохранилось — звёздочка проживёт до перезагрузки.
  }

  listeners.forEach((listener) => {
    listener();
  });
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

const EMPTY: string[] = [];

/** Короткие имена избранных моделей сайта. */
export function useFavorites(siteId: string | undefined): string[] {
  return useSyncExternalStore(
    subscribe,
    () => (siteId === undefined ? EMPTY : read(siteId)),
    () => EMPTY,
  );
}
